import { Edit, MessageSquare, Eye } from "lucide-react";
import {
  Card,
  Button,
  quotesTableConfig,
  mockQuotes,
  getStatusProps,
} from "@b2b/ui-components";
import DataTable from "./Datatable/DataTable";

const transformedData = mockQuotes.map((q) => {
  const { icon, classes } = getStatusProps(q.status);

  return {
    ...q,
    status: (
      <div
        className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${classes}`}
      >
        {icon}
        <span>{q.status.charAt(0).toUpperCase() + q.status.slice(1)}</span>
      </div>
    ),
    submittedDate: new Date(q.submittedDate).toLocaleDateString(),
    actions: (
      <div className="flex gap-1">
        <Button variant="outline" size="sm" className="h-8 px-2">
          <Edit className="w-3 h-3 mr-1" />
          Edit
        </Button>
        <Button variant="outline" size="sm" className="h-8 px-2">
          <Eye className="w-3 h-3" />
          View
        </Button>
      </div>
    ),
    message: (
      <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
        <MessageSquare className="w-4 h-4" />
      </Button>
    ),
  };
});

export function QuotesTable() {
  return (
    <Card className="bg-white border shadow-sm">
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-lg font-semibold text-foreground">
            Submitted Quotes
          </h3>
          <div className="text-sm text-gray-500">
            {mockQuotes.length} quote{mockQuotes.length !== 1 ? "s" : ""} found
          </div>
        </div>

        {mockQuotes.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-500">
              No quotes available. Quotes/RFQ feature backend is not yet implemented.
            </p>
          </div>
        ) : (
          <DataTable
            data={transformedData}
            config={quotesTableConfig}
            rowsPerPage={3}
          />
        )}
      </div>
    </Card>
  );
}
